import { Link } from "react-router-dom";
import "../styles/footer.css";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="ix-footer">
      <div className="ix-shell">
        <div className="ix-footer-top">
          <div className="ix-footer-brand">
            <p>
              Putting institutional grade intelligence in everyone&rsquo;s hands.
              Secure, backed by evidence, traceable to the source.
            </p>
            <a className="ix-footer-email" href="mailto:osama@intellusionai.com">
              osama@intellusionai.com
            </a>
          </div>

          <div className="ix-footer-col">
            <h5>Products</h5>
            <a href="https://www.stocklenshq.com" target="_blank" rel="noopener noreferrer">StockLens</a>
            <Link to="/projects">MHX</Link>
            <a href="https://networkxjobs.com/" target="_blank" rel="noopener noreferrer">NetworkX</a>
            <Link to="/bill-y">Bill-y</Link>
          </div>

          <div className="ix-footer-col">
            <h5>Company</h5>
            <Link to="/about">Mission</Link>
            <Link to="/ilab">iLab</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="ix-footer-col">
            <h5>Legal</h5>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </div>

        <svg
          className="ix-footer-wordmark"
          viewBox="0 0 1000 185"
          preserveAspectRatio="xMidYMid meet"
          aria-hidden="true"
        >
          <text x="500" y="145" textAnchor="middle" textLength="1000" lengthAdjust="spacingAndGlyphs">
            in<tspan className="r">tel</tspan>lus<tspan className="g">ion</tspan>
          </text>
        </svg>

        <div className="ix-footer-bottom">
          <span>{year} &copy; INTELLUSION</span>
          <span>INTELLIGENCE FOR EVERYONE</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
